export default "__VITE_ASSET__BGsjigJG__"